import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css'


//                 %a{ href: "/#{lang}/orders/#{rec[:joborderid]}" }=rec[:joborderid].strip
class OrderTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            jobs: [],
        };
    }

    async componentWillMount() {
        this.setState({loading: true});
        const resp = await fetch(`/webservice/orders?page=0&limit=1000`);
        const json = await resp.json();
        this.setState({
            loading: false,
            jobs: json,
        })
    }

    render() {
        const { headers } = this.props;
        const columns = [
            {
                id: 'joborderid',
                Header: headers[0],
                Cell: c => {
                    const { original } = c;
                    return <a href={`orders/${original.joborderid}/`}>{original.joborderid}</a>
                },
                accessor: 'joborderid'
            },
            { Header: headers[1], accessor: 'jobpatient' },
            { Header: headers[2], accessor: 'jobtray' },
            { Header: headers[3], accessor: 'jobstation' },
            { Header: headers[4], accessor: 'jobstatus' },
            { Header: headers[5], accessor: 'jobstatusdesc', },
            { Header: headers[6], accessor: 'jobrecvdate' }
        ];
        return(
            <ReactTable
                data={this.state.jobs}
                columns={columns}
                filterable={true}
                defaultFilterMethod={(search, item) => {
                    const query = search.value;
                    const str = item[search.id];
                    if(str) {
                        return str.toLowerCase().startsWith(query.toLowerCase());
                    } else {
                        return false;
                    }
                }}
                className={'-striped -highlight'}
                loading={this.state.loading}
            />
        )
    }
}


export default OrderTable;
